//import React, { useState, useEffect, forwardRef } from 'react';
import useTranslations from '@/apps/providers/useTranslations';

/**
 * ChatInput - Input field for sending chat messages
 * Supports text input with send button and voice input (future)
 */
const ChatInput = React.forwardRef(({ onSendMessage, disabled }, ref) => {
  const { tr, locale } = useTranslations();
  const [inputValue, setInputValue] = React.useState('');
  const [isListening, setIsListening] = React.useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (inputValue.trim() && !disabled) {
      onSendMessage(inputValue);
      setInputValue('');
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSubmit(e);
    }
  };

  const handleVoiceInput = () => {
    // TODO: Implement voice input using Web Speech API
    if ('webkitSpeechRecognition' in window || 'SpeechRecognition' in window) {
      setIsListening(true);

      const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
      const recognition = new SpeechRecognition();
      recognition.continuous = false;
      recognition.interimResults = false;
      // Set language based on locale
      recognition.lang = locale === 'es_CO' ? 'es-CO' : 'en-US';

      recognition.onresult = (event) => {
        const transcript = event.results[0][0].transcript;
        setInputValue(transcript);
        setIsListening(false);
      };

      recognition.onerror = () => {
        setIsListening(false);
      };

      recognition.onend = () => {
        setIsListening(false);
      };

      recognition.start();
    } else {
      alert(tr('chat.input.voice_not_supported'));
    }
  };

  return (
    <form className="chat-input-container" onSubmit={handleSubmit}>
      <input
        ref={ref}
        type="text"
        className="chat-input-field"
        placeholder={tr('chat.input.placeholder')}
        value={inputValue}
        onChange={(e) => setInputValue(e.target.value)}
        onKeyDown={handleKeyDown}
        disabled={disabled}
        maxLength={500}
      />

      <button
        type="button"
        className="chat-voice-btn"
        onClick={handleVoiceInput}
        disabled={disabled}
        aria-label={tr('chat.input.voice')}
        title={tr('chat.input.voice')}
      >
        {isListening ? (
          <div className="voice-listening">
            <span></span>
            <span></span>
            <span></span>
          </div>
        ) : (
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          >
            <path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z" />
            <path d="M19 10v2a7 7 0 0 1-14 0v-2" />
            <line x1="12" y1="19" x2="12" y2="23" />
            <line x1="8" y1="23" x2="16" y2="23" />
          </svg>
        )}
      </button>

      <button
        type="submit"
        className="chat-send-btn"
        disabled={disabled || !inputValue.trim()}
        aria-label={tr('chat.input.send')}
      >
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
        >
          <line x1="22" y1="2" x2="11" y2="13" />
          <polygon points="22 2 15 22 11 13" />
        </svg>
      </button>
    </form>
  );
});

export default ChatInput;
